// Suppress ResizeObserver errors that are common with Monaco Editor
// These are benign warnings that don't affect functionality

export function suppressResizeObserverError() {
  // Suppress console errors
  const resizeObserverErr = window.console.error;
  window.console.error = (...args: any[]) => {
    const arg = args[0];
    if (typeof arg === 'string' && 
        (arg.includes('ResizeObserver loop completed with undelivered notifications') ||
         arg.includes('ResizeObserver loop limit exceeded'))) {
      return;
    }
    resizeObserverErr.apply(window.console, args);
  };

  // Also suppress the error at the window level
  window.addEventListener('error', (e) => {
    if (e.message?.includes('ResizeObserver loop completed with undelivered notifications') ||
        e.message?.includes('ResizeObserver loop limit exceeded')) {
      e.stopImmediatePropagation();
      e.stopPropagation();
      e.preventDefault();
      return false;
    }
  }, true);

  // Note: We don't override window.Error as it causes issues with "Class constructors cannot be invoked without 'new'"
  // The console.error override and window error listener above are sufficient to suppress ResizeObserver errors
}